"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAdaptableObject = void 0;
// pretty primitive type guard for AdaptableObject, but currently there is no better/safer way
const isAdaptableObject = (object) => {
    return object != undefined && typeof object['Uuid'] === 'string';
};
exports.isAdaptableObject = isAdaptableObject;
